import { Navigate } from '@tanstack/react-router'

import { SignInPage } from './SignInPage'
import { useAuth } from '@/features/auth/useAuth'

/**
 * Sign-in and sign-up as addressable pages.
 *
 * The application itself gates by swapping the subtree — no redirect, so signing in leaves
 * you where you were. That works for someone who is already inside the product and has no
 * URL to link to; a landing page needs one, and "create an account" has to be a link a
 * person can be sent.
 *
 * Signed in already, these are a dead end, so they hand you to the product instead.
 */
export function AuthEntry({ mode = 'signin' }: { mode?: 'signin' | 'signup' }) {
  const { user, isLoading } = useAuth()

  if (isLoading) return <div className="min-h-full bg-ground" aria-busy="true" />
  if (user) return <Navigate to="/chat" replace />

  return <SignInPage initialMode={mode} />
}
